// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ui-empty-EswYWy{justify-content:center;align-items:center;width:100%;height:100%;padding-bottom:5%;display:flex}.ui-empty-EswYWy .semi-empty-content{margin-top:16px}.ui-empty-EswYWy .semi-empty-title{font-size:16px!important}.ui-empty-EswYWy .semi-empty-description{font-size:14px}.ui-empty-EswYWy .semi-empty-title+.semi-empty-description{margin-top:4px}.ui-empty-EswYWy .semi-empty-footer{justify-content:center;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-empty": `ui-empty-EswYWy`,
	"uiEmpty": `ui-empty-EswYWy`
};
export default ___CSS_LOADER_EXPORT___;
